<template>

    <img :src="payload" />


</template>

<script>
import usePreload from '../../helpers/preload';

export default {

    data(){
        return {
            payload: null,
        }
    },

    props: [ 'src' ],

    async created () {
        const data = await usePreload(this.src)        
        this.payload = URL.createObjectURL(data)
    }
}

</script>